
import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/form.module'

export default function CategoryBasicInfoComponent ({handleParentCategorySearch,parentCategories,handleInnerFormChange,selectedCategory}: any) {
  return (
    <>
 <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
<InputContainer

            label="Name"
            name="Name"
            onValueChange={(event: any) => {
              handleInnerFormChange(
                event.target.value,
                'Name'
              )
            }}
            type="text"
            value={selectedCategory?.Name}
        />

  <InputContainer
              label="Code"
              name="Code"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Code'
                )
              }}
              type="text"
              value={selectedCategory?.Code}
          />

          <InputContainer
              label="SubCategory"
              name="IsSubCategory"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsSubCategory'
                )
              }}
              type="checkbox"
              value={selectedCategory?.IsSubCategory}
          />
  {selectedCategory?.IsSubCategory && <InputContainer
               label="Parent Category"
               labelField="Name"
               list={parentCategories}
               onTypeahead={(event: any) => handleParentCategorySearch({ event })}
               onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'ParentCategoryId'
                )
               }}
               type="typeahead"
               value={selectedCategory?.ParentCategoryId}
               valueField="Id"
           />}
      </div>
   
  }
    expandedPanel="basicInfo"
    headerTitle="Basic Information"
/>
    
        </>
  )
}